import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, PhoneIcon } from 'lucide-react';
import { ModalityOrbit } from './ModalityOrbit';
import { orbitNodes } from '../../data/modalities';
const fade = {
  hidden: {
    opacity: 0,
    y: 16
  },
  show: (index: number) => ({
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      delay: index * 0.08,
      ease: [0.22, 1, 0.36, 1]
    }
  })
};
export function Hero() {
  return <section className="relative w-full overflow-hidden bg-white" data-id="element-73" data-mp="3783j6obg4b07">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-[420px] bg-gradient-to-b from-slate-50 to-white" data-id="element-74" data-mp="3c3slv0iri80q" />
      <div className="relative mx-auto grid max-w-7xl items-center gap-10 px-5 py-16 sm:px-8 lg:grid-cols-[1.05fr_0.95fr] lg:py-24" data-id="element-75" data-mp="3h4yfr1o5s1bu">
        <div className="max-w-xl" data-id="element-76" data-mp="1mqfbounyxprp">
          <motion.p variants={fade} initial="hidden" animate="show" custom={0} className="text-[12px] font-semibold uppercase tracking-[0.16em] text-teal" data-id="element-77" data-mp="1mrgy1vafpyoq">
            Therapeutic Modalities, Matched to Your Practice
          </motion.p>
          <motion.h1 variants={fade} initial="hidden" animate="show" custom={1} className="mt-4 font-display text-4xl font-extrabold leading-[1.05] tracking-tight text-navy sm:text-5xl lg:text-[3.4rem]" data-id="element-78" data-mp="1y6apd0nz4vnf">
            More Than Equipment. The Right Technology, Implemented the Right
            Way.
          </motion.h1>
          <motion.p variants={fade} initial="hidden" animate="show" custom={2} className="mt-6 text-[17px] leading-relaxed text-charcoal/75" data-id="element-79" data-mp="2gzodomx6m3u2">
            JAG Medical Solutions helps doctors cut through modality hype,
            compare proven technologies, and choose equipment that fits their
            patients, team, and growth goals.
          </motion.p>
          <motion.div variants={fade} initial="hidden" animate="show" custom={3} className="mt-8 flex flex-col gap-3 sm:flex-row" data-id="element-80" data-mp="vn4trh3azch3">
            <a href="tel:+19414416131" className="inline-flex items-center justify-center gap-2 rounded-full bg-navy px-7 py-3.5 text-[15px] font-semibold text-white transition-colors hover:bg-navy/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal focus-visible:ring-offset-2" data-id="element-81" data-mp="3nq83h5vhjw13">
              <PhoneIcon className="h-[18px] w-[18px]" data-id="element-82" data-mp="34tyehnj1pl2b" />
              Call (941) 441-6131
            </a>
            <a href="#products" className="inline-flex items-center justify-center gap-2 rounded-full border border-slate-200 bg-white px-7 py-3.5 text-[15px] font-semibold text-navy transition-colors hover:border-teal hover:text-teal focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal focus-visible:ring-offset-2" data-id="element-83" data-mp="2r3ctnta1711s">
              Explore Product Categories
              <ArrowRightIcon className="h-[18px] w-[18px]" data-id="element-84" data-mp="22hxagz4evnzy" />
            </a>
          </motion.div>
          <motion.p variants={fade} initial="hidden" animate="show" custom={4} className="mt-4 text-sm font-medium text-charcoal/60" data-id="element-85" data-mp="1yhejf7acelyt">
            Talk with JAG Medical Solutions about the right fit for your
            practice.
          </motion.p>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2,
        ease: [0.22, 1, 0.36, 1]
      }} className="hidden justify-center lg:flex" data-id="element-86" data-mp="2heo2gnbr9xfj">
          <ModalityOrbit data-id="element-87" data-mp="354ic6w0s35vk" />
        </motion.div>

        <div className="grid grid-cols-2 gap-3 lg:hidden" data-id="element-88" data-mp="305pas1yrn5br">
          {orbitNodes.map(node => <div key={node.id} className="rounded-2xl border border-slate-100 bg-white p-4 shadow-sm" data-id="element-89" data-mp="xj1v7yj4xfoa">
              <div className="flex items-start justify-between gap-2" data-id="element-90" data-mp="12fs8ke3k1x60">
                <p className="font-display text-sm font-bold leading-tight text-navy" data-id="element-91" data-mp="179cx7fj9desj">
                  {node.name}
                </p>
                {node.status && <span className="shrink-0 rounded-full bg-teal/10 px-2 py-1 text-[9px] font-semibold uppercase tracking-wide text-teal" data-id="element-92" data-mp="ejw92u2o8k24">
                    Coming soon
                  </span>}
              </div>
              <p className="mt-1.5 text-xs leading-snug text-charcoal/55" data-id="element-93" data-mp="oh0xl0jzorm3">
                {node.detail}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}